import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

// A3I setting's submenu config
export interface A3iSettingConfig {
	hasFooter: boolean; // The sub menu has footer or not
	title: string; // Sub menu's title
}

@Injectable()
export class A3iSettingService {

	// A3I setting's submenu config
	settingConfig: BehaviorSubject<A3iSettingConfig> = new BehaviorSubject(null);

	constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/common-services/a3i-setting.service.ts